import { render, staticRenderFns } from "./ActiveBackupRepoLocks.vue?vue&type=template&id=2c01aff6&"
import script from "./ActiveBackupRepoLocks.vue?vue&type=script&lang=ts&"
export * from "./ActiveBackupRepoLocks.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports